module.exports = __webpack_public_path__ + "img/clothing103.8a0ef9e4.jpg";